import { EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { Stock } from "../models";
import { stockAdapter } from "../state";

import * as fromActions from '../actions';

const initState: EntityState<Stock> = stockAdapter.getInitialState();

export const stockReducer = createReducer(
  initState,
  on(fromActions.loadStock, (state, { stock }) => stockAdapter.setAll(stock, state))
)

export const resultsCountReducer = createReducer(
  0,
  on(fromActions.setResultsCount, (state, { count }) => count)
)
